<template>
  <div
    class="i-base-delimiter"
    :style="{ backgroundColor: props.color }"
  ></div>
</template>

<script setup lang="ts">
import { black200 } from "@/styles/colors"

const props = defineProps({
  color: {
    type: String,
    default: black200
  }
})
</script>

<style lang="scss" scoped>
.i-base-delimiter {
  height: 1px;
  margin: 8px 0;
}
</style>
